import Cookies from 'js-cookie'

const TokenKey = 'goodeey_root_token_key'
const LoginUserKey = 'goodeey_login_root'

export function getToken() {
  return Cookies.get(TokenKey)
}
export function setToken(token, expire) {
  if (expire) {
    return Cookies.set(TokenKey, token, {expires: expire / 60 / 60 / 24})
  } else {
    return Cookies.set(TokenKey, token)
  }
}
export function removeToken() {
  return Cookies.remove(TokenKey)
}



export function getLoginUser() {
  let data = Cookies.get(LoginUserKey)
  return data ? JSON.parse(data) : false
}
export function setLoginUser(data, expire) {
  if (expire) {
    return Cookies.set(LoginUserKey, JSON.stringify(data), {expires: expire / 60 / 60 / 24})
  } else {
    return Cookies.set(LoginUserKey, JSON.stringify(data))
  }
}
export function removeLoginUser() {
  return Cookies.remove(LoginUserKey)
}


export function removeAll() {
  Cookies.remove(TokenKey)
  Cookies.remove(LoginUserKey)
  return true
}
